import { render, staticRenderFns } from "./NewTeam.vue?vue&type=template&id=14126a70&"
import script from "./NewTeam.vue?vue&type=script&lang=js&"
export * from "./NewTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewTeam.vue"
export default component.exports